<template>
  <div class="qualifications">
    <el-row :gutter="24">
      <el-col :span="24">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px" class="demo-ruleForm">
          <el-form-item label="职称" prop="level">
            <el-select style="width: 69%;" v-model="ruleForm.level" placeholder="请选择职称" no-data-text="暂时没数据">
              <el-option v-for="(item,index) in level_list" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-row v-if="ruleForm.level_text != ''" type="flex" class="row-bg">
            <el-col :span="12">
              <el-form-item label="药师职称证号" prop="titleNo">
                <el-input style="width: 63%;" v-model="ruleForm.titleNo" placeholder="药师执业证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职称证取得时间" prop="titleRecDate">
                <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.titleRecDate"
                  style="width: 64%;" :picker-options="pickerOptions0"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="ruleForm.level_text != ''" type="flex" class="row-bg">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-form-item label="职称附件正面" prop="titleCert">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res, file, 'titleCert')}" :before-upload="beforeAvatarUpload"
                    :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
                    :on-exceed="handleExceed">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.titleCert !='' &&  ruleForm.titleCert != null">
                  <div class="doctor_title">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.titleCertText" :preview-src-list="[ruleForm.titleCertText]">
                    </el-image>
                  </div>
                  
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/title1.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-form-item label="职称附件反面" prop="titleCertBack">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res, file, 'titleCertBack')}" :before-upload="beforeAvatarUpload"
                    :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
                    :on-exceed="handleExceed">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.titleCertBack !='' &&  ruleForm.titleCertBack != null">
                  <div class="titleCertBack">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.titleCertBackText" :preview-src-list="[ruleForm.titleCertBackText]">
                    </el-image>
                  </div>
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/title2.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="ruleForm.level_text != ''" type="flex" class="row-bg">
            <el-col :span="12">
              <el-form-item label="药师资格证号" prop="certNo">
                <el-input style="width: 63%;" v-model="ruleForm.certNo" placeholder="药师资格证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资格证取得时间" prop="certRecDate">
                <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.certRecDate"
                  style="width: 63%;" :picker-options="pickerOptions0"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-form-item label="药师资格证正面" prop="doctorCertificate">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res, file, 'doctorCertificate')}"
                    :before-upload="beforeAvatarUpload" :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed">
                    <el-button  size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.doctorCertificate !='' &&  ruleForm.doctorCertificate != null">
                  <div class="doctor_certificate">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.doctorCertificateText"
                      :preview-src-list="[ruleForm.doctorCertificateText]"></el-image>
                  </div>
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/doctor_certificate1.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-form-item label="药师资格证反面" prop="doctorCertificateBack">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res, file, 'doctorCertificateBack')}"
                    :before-upload="beforeAvatarUpload" :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed">
                    <el-button  size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.doctorCertificateBack !='' &&  ruleForm.doctorCertificateBack != null">
                  <div class="doctor_certificate_back">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.doctorCertificateBackText"
                      :preview-src-list="[ruleForm.doctorCertificateBackText]"></el-image>
                  </div>
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/doctor_certificate2.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="ruleForm.level_text != ''" type="flex" class="row-bg">
            <el-col :span="12">
              <el-form-item label="药师执业证号" prop="pracNo">
                <el-input style="width: 63%;" v-model="ruleForm.pracNo" placeholder="药师执业证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执业证取得时间" prop="pracRecDate">
                <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.pracRecDate"
                  style="width: 63%;" :picker-options="pickerOptions0"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-form-item label="执业资格证正面" prop="cocationalCertificate">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res,file,'cocationalCertificate')}"
                    :before-upload="beforeAvatarUpload" :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.cocationalCertificateBack !='' &&  ruleForm.cocationalCertificateBack != null">
                  <div class="cocational_certificate">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.cocationalCertificateText"
                      :preview-src-list="[ruleForm.cocationalCertificateText]"></el-image>
                  </div>
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/cocational_fileList1.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-form-item label="执业资格证反面" prop="cocationalCertificateBack">
                  <el-upload class="upload-demo" :headers="{'uploadType':'phr_profile'}"
                    :on-success="function (res,file) {return handleLearnDataSuccess(res,file,'cocationalCertificateBack')}"
                    :before-upload="beforeAvatarUpload" :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                    <el-button  size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200kb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.cocationalCertificateBack !='' &&  ruleForm.cocationalCertificateBack != null">
                  <div class="cocational_certificate_back">
                    <el-image style="width: 300px; height: 200px" :src="ruleForm.cocationalCertificateBackText"
                      :preview-src-list="[ruleForm.cocationalCertificateBackText]"></el-image>
                  </div>
                  <el-popover placement="left-end" width="400" trigger="hover">
                    <div class="front-img">
                      <img src="../../../../../assets/images/cocational_fileList2.jpg" alt />
                    </div>
                    <!-- <span>样本示例</span> -->
                    <el-button style="margin-top: 20px;" slot="reference">样本示例</el-button>
                  </el-popover>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row class="btn_all">
            <el-button class="customBtn" @click="$router.back(-1)" v-if="againChange">上一步</el-button>
            <el-button class="customBtnNext" type="primary" @click="submitForm('ruleForm')"  v-if="ruleForm.status === 0 || ruleForm.status === -1">保存
            </el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import util from "@/utils";
import {mapState} from 'vuex'
import {
  doctorEdit,
  uploadFile,
  getDoctorInfo,
  getSystem
} from "@/api/index.js";
export default {
  name: 'Qualifications',
  data() {
    return {
      ruleForm: {},
      rules: {
        titleNo: [
          {
            required: true,
            message: "职称证号不能为空",
            trigger: "blur"
          },
          { min: 5, max: 15, message: "长度在 5 到 15 个字符", trigger: "blur" }
        ],
        titleRecDate: [
          {
            required: true,
            message: "职称取得时间不能为空",
            trigger: "blur"
          }
        ],
        certNo: [
          {
            required: true,
            message: "资格证号不能为空",
            trigger: "blur"
          },
          { min: 5, max: 15, message: "长度在 5 到 15 个字符", trigger: "blur" }
        ],
        certRecDate: [
          {
            required: true,
            message: "资格证取得时间不能为空",
            trigger: "blur"
          }
        ],
        pracNo: [
          {
            required: true,
            message: "药师执业证不能为空",
            trigger: "blur"
          },
          { min: 5, max: 15, message: "长度在 5 到 15 个字符", trigger: "blur" }
        ],
        pracRecDate: [
          {
            required: true,
            message: "执业证取得时间不能为空",
            trigger: "blur"
          }
        ],
        level: [
          {
            required: true,
            message: "职称不能为空",
            trigger: "blur"
          }
        ],
        titleCert: [
          {
            required: true,
            message: "职称附件正面不能为空",
            trigger: "blur"
          }
        ],
        titleCertBack: [
          {
            required: true,
            message: "职称附件反面不能为空",
            trigger: "blur"
          }
        ],
        doctorCertificate: [
          {
            required: true,
            message: "药师资格证正面不能为空",
            trigger: "blur"
          }
        ],
        doctorCertificateBack: [
          {
            required: true,
            message: "药师资格证反面不能为空",
            trigger: "blur"
          }
        ],
        cocationalCertificate: [
          {
            required: true,
            message: "执业资格证正面不能为空",
            trigger: "blur"
          }
        ],
        cocationalCertificateBack: [
          {
            required: true,
            message: "执业资格证反面不能为空",
            trigger: "blur"
          }
        ]
      },
      level_list: "", //职称列表
      fileList: [],
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      pickerOptions0: {  //elementUI不能选择超过当天的日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    };
  },
  mounted() {
    this.getUserInfo();
    this.getTitle();
    this.$store.commit('updateActive', 3)
  },
  computed:{
    ...mapState(['againChange'])
  },
  methods: {
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params)
        if (res.success) {
          this.ruleForm = res.result;
          this.ruleForm.level = this.ruleForm.level + ""
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取医生职称--字典
     */
    getTitle() {
      const that = this;
      const params = {};
      getSystem(params).then(res => {
        that.level_list = res.result.doctor_level;
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type
      });
    },
    //提交
    submitForm(formName) {

      const that = this;
      this.$refs[formName].validate(async valid => {
        try {
          if (valid) {
            //type: "qualified",
            let res = await doctorEdit(that.ruleForm);
            if (res.success) {
              this.elementTips("success", res.message);
              this.getUserInfo();
              this.$router.push('/index/user/auditInformation/auditInfo')

            } else {
              this.elementTips("warning", res.message);
            }
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt200k = file.size / 1024 < 200;
      if (!isJPG) {
        this.$message.error("图片格式错误");
      }
      if (!isLt200k) {
        this.$message.error("上传图片大小不能超过 200kb!");
      }
      return isJPG && isLt200k;
    },
    /**
     * 上传成功的回调
     *
     */
    handleLearnDataSuccess(res, file, index) {
      const that = this;
      if (res.success) {
        this.elementTips("success", res.message);
        this.ruleForm[index] = res.result.relativePath;
        this.ruleForm[`${index}Text`] = res.result.absolutePath;
      } else {
        this.elementTips("warning", res.message);
      }
    },
    /**
     * 删除函数
     */
    handleRemove(file, fileList) {
      if (!file.response) {
        return;
      }
      if (this.ruleForm.titleCert.indexOf(file.response.result.relativePath) != -1) {
        this.ruleForm.titleCert = "";
        this.ruleForm.titleCertText = "";
      } else if (
        this.ruleForm.titleCertBack.indexOf(file.response.result.relativePath) != -1
      ) {
        this.ruleForm.titleCertBackText = "";
        this.ruleForm.titleCertBack = "";
      } else if (
        this.ruleForm.doctorCertificate.indexOf(file.response.result.relativePath) != -1
      ) {
        this.ruleForm.doctorCertificate = "";
        this.ruleForm.doctorCertificateText = "";
      } else if (
        this.ruleForm.doctorCertificateBack.indexOf(file.response.result.relativePath) !=
        -1
      ) {
        this.ruleForm.doctorCertificateBack = "";
        this.ruleForm.doctorCertificateBackText = "";
      } else if (
        this.ruleForm.cocationalCertificate.indexOf(file.response.result.relativePath) !=
        -1
      ) {
        this.ruleForm.cocationalCertificate = "";
        this.ruleForm.cocationalCertificateText = "";
      } else if (
        this.ruleForm.cocationalCertificateBack.indexOf(
          file.response.result.relativePath
        ) != -1
      ) {
        this.ruleForm.cocationalCertificateBack = "";
        this.ruleForm.cocationalCertificateBackText = "";
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      if (file.status == "ready") {
        return;
      }
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style scoped>
.doctor_certificate {
  width: 200px;
  height: 200px;
}
.front-img {
  display: block;
  /* float: right; */
  width: 300px;
  height: 200px;
}
.front-img img {
  width: 100%;
  height: 100%;
}
.customBtn {
  width: 100%;
}
.customBtnNext {
  width: 100%;
}

.el-upload-list__item .el-upload-list__item-status-label{
  right: 50%!important;
}
</style>
